import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 15.25,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7938 13.4295H17.2062V21.7938C17.2062 22.46 16.6662 23 16 23C15.3338 23 14.7938 22.46 14.7938 21.7938V13.4295ZM16 12.0953C15.5567 12.0953 15.1959 11.9471 14.9175 11.6506C14.6392 11.3541 14.5 10.9864 14.5 10.5476C14.5 10.1089 14.6392 9.74121 14.9175 9.44473C15.1959 9.14824 15.5567 9 16 9C16.4433 9 16.8041 9.14231 17.0825 9.42694C17.3608 9.71156 17.5 10.0673 17.5 10.4943C17.5 10.9568 17.3608 11.3422 17.0825 11.6506C16.8041 11.9471 16.4433 12.0953 16 12.0953Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgInfoCircle);
export default ForwardRef;
